// extracted by mini-css-extract-plugin
export var discard = "_2o-4";
export var muiTooltipTooltip = "_2o-6";
export var notificationBar = "_2o-3";
export var notificationContainer = "_2o-2";
export var saveButtonHoverSlotWrapper = "_2o-5";
export var show = "_2o-1";
export var spacer = "_2o-0";